import PoLinePhysicalSerial from './po-line-physical-serial';
export default class ViewOrSelectSerialInfo { 
    lineId: number;
    sku:string;
    productName:string;
    orderQty: number;
    selectQty: number;
    serialNosReceived: Array<string>;
    serialNosAvailable: Array<PoLinePhysicalSerial>;
}